import type { Resource } from '../../';
export const product_details_update: Resource = {"default":"Update"};
